<div class="hlt-container" #elContainer>
  <div class="hlt-backdrop" #elBackdrop>
    <div class="hlt-highlights" #elHighlights></div>
  </div>
  <textarea
    #elTextarea
    class="hlt-textarea"
    [readonly]="readonly"
    [ngModel]="texto"
    (ngModelChange)="onChangeAction($event)"
    (scroll)="onScrollAction()"
    (select)="onSelectionAction($event)">
  </textarea>
</div>
